export default __webpack_public_path__ + "static/media/requisiciones-sistema.a4854bbf.png";